import React, { useMemo } from 'react';

interface YoufeedStarProps extends React.SVGProps<SVGSVGElement> {
  gradient?: {
    gradient1: string;
    gradient2: string;
  };
}

const YoufeedStar: React.FC<YoufeedStarProps> = ({ gradient, ...props }) => {
  const gradientId = useMemo(
    () => 'grad-' + Math.random().toString(36).substr(2, 9),
    []
  );
  return (
    <svg {...props} viewBox="0 0 46 45" xmlns="http://www.w3.org/2000/svg">
      {gradient && (
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={gradient.gradient1} />
            <stop offset="100%" stopColor={gradient.gradient2} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M23 0L28.3883 16.9291L45.8254 16.9291L31.7185 27.3918L37.1068 44.3209L23 33.8582L8.89315 44.3209L14.2815 27.3918L0.174644 16.9291L17.6117 16.9291L23 0Z"
        fill={gradient ? `url(#${gradientId})` : 'currentColor'}
      />
    </svg>
  );
};

export default YoufeedStar;
